export default __webpack_public_path__ + "static/media/Patch contraceptif.6ce2dd4c.png";